export function Accordion({ title, children, open, onToggle }) {
    return (
        <div className="accordion">
            <button
                className="accordion-header"
                onClick={onToggle}
                aria-expanded={open}
            >
                <span className="accordion-title">{title}</span>
                <span className="accordion-icon" />
            </button>

            <div className={`accordion-body ${open ? "is-open" : ""}`}>
                <div className="accordion-body-inner">
                    {children}
                </div>
            </div>
        </div>
    );
}